/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import AgGrid from "./AgGrid"; import ReactDOM from 'react-dom';
import _ from "lodash";
import Modal from 'react-responsive-modal';
import SweetAlert from 'react-bootstrap-sweetalert';
import CountUp from 'react-countup';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import Select from 'react-select';
import { getDDMMYYYY, getDDMMYYYYHHMMSS, getYYYYMMDD, getHyphenDDMMMYYYYHHMM, getYYYYMMDDHHMMSS } from '../common/utils';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import redirectURL from "../redirectURL";
var moment = require('moment');

const decipher = salt => {
    const textToChars = text => text.split('').map(c => c.charCodeAt(0));
    const applySaltToChar = code => textToChars(salt).reduce((a, b) => a ^ b, code);
    return encoded => encoded.match(/.{1,2}/g)
        .map(hex => parseInt(hex, 16))
        .map(applySaltToChar)
        .map(charCode => String.fromCharCode(charCode))
        .join('');
}
var decode = decipher("V744c@XBTY!uHWA#v6Fe$GXmx%EXuN&ov(6fkW)x");

export default class DealerDetentionReport extends Component {
    state = {
        show: false,
        basicTitle: '',
        basicType: "default",
        loadshow: "show-n",
        overly: "show-n",
        dept_code: "",
        totalTrucks: [],
        truckscnt: 0,
        rowData: [],
        pivotmodeis: false,
        pivotcols: [],
        defaultColDef: {
            sortable: true,
            filter: true,
            resizable: true

        },
        frameworkComponents: {
        },
        rowModelhighchartoptionsType: 'enterprise',
        rowGroupPanelShow: 'always',
        animateRows: true,
        debug: true,
        showToolPanel: true,
        startDate: new Date(moment.parseZone().subtract(1, "week")),
        endDate: new Date(moment.parseZone()),
        suppressAggFuncInHeader: true,
        statusBar: {
            statusPanels: [
                {
                    statusPanel: "agTotalAndFilteredRowCountComponent",
                    align: "left"
                },
                {
                    statusPanel: "agTotalRowCountComponent",
                    align: "center"
                },
                { statusPanel: "agFilteredRowCountComponent" },
                { statusPanel: "agSelectedRowCountComponent" },
                { statusPanel: "agAggregationComponent" }
            ]
        },
        sideBar: {
            toolPanels: [
                {
                    id: "columns",
                    labelDefault: "Columns",
                    labelKey: "columns",
                    iconKey: "columns",
                    toolPanel: "agColumnsToolPanel"
                },
                {
                    id: "filters",
                    labelDefault: "Filters",
                    labelKey: "filters",
                    iconKey: "filter",
                    toolPanel: "agFiltersToolPanel"
                }
            ]
        },
        from_date: moment.parseZone().startOf("day").format("YYYY-MM-DD"),
        to_date: moment.parseZone().endOf("day").format("YYYY-MM-DD"),
        selectedFilter: []
    }
    cipher = (salt) => {
        const textToChars = text => text.split('').map(c => c.charCodeAt(0));
        const byteHex = n => ("0" + Number(n).toString(16)).substr(-2);
        const applySaltToChar = code => textToChars(salt).reduce((a, b) => a ^ b, code);
        try {
            return text => text.split('')
                .map(textToChars)
                .map(applySaltToChar)
                .map(byteHex)
                .join('');
        }
        catch (e) { 
            return e
        }
    }

    componentDidMount() {
        let from_date = moment.parseZone().subtract(1, "week").startOf("day").format("YYYY-MM-DD HH:mm:ss");
        let to_date = moment.parseZone().endOf("day").format("YYYY-MM-DD HH:mm:ss");
        let params = {
            from_date, to_date,
            "search_type": "left_dealer_time"
        }
        if (this.state.selectedFilter == "Invoice Time") {
            params = {
                from_date, to_date,
                "search_type": "invoice_time"
            }
        }
        else if (this.state.selectedFilter == "Left Dealer Time") {
            params = {
                from_date, to_date,
                "search_type": "left_dealer_time"
            }
        }
        this.setState({
            loadshow: "show-m",
            overlay: "show_m"
        })
        this.getDashboardRowData(params)
    }
    getDashboardRowData = (params) => {
        redirectURL.post("/getDealerDetentionReport", params).then(resp => {
            const rowData = JSON.parse(resp.data.apiData)
            const rowGridData = []
            if (rowData["response_data"] !== undefined) {
                rowGridData.push(JSON.parse(rowData["response_data"]))
                console.log("rowData", rowData)
                console.log("rowGridData", rowGridData)
                this.setState({
                    rowData: rowGridData[0],
                    loadshow: 'show-n',
                    overly: 'show-n'
                })
            }

        })
    }

    onClickHideAll = () => {
        this.setState({
            overly: "show-n",
            loadshow: "show-n",
            show: false
        })
    }

    closeAlert = () => {
        this.setState({
            show: false,
            title: ""
        })
    }
    getDealerDetails = event => {
        event.preventDefault();
        this.setState({
            loadshow: "show-m",
            overly: "show-m"
        })
        const { startDate, endDate } = this.state

        let sdate = moment.parseZone(new Date(startDate)).utcOffset("+05:30").format("YYYY-MM-DD") + " 00:00:00"
        let edate = moment.parseZone(new Date(endDate)).utcOffset("+05:30").format("YYYY-MM-DD") + " 23:59:59"
        let params = { "search_type": "left_dealer_time", from_date: sdate, to_date: edate }
        let selectedFilter = this.state.selectedFilter

        if (selectedFilter == "Invoice Time") {
            params = { "search_type": "invoice_time", from_date: sdate, to_date: edate }
        }
        else if (selectedFilter == "Left Dealer Time") {
            params = { "search_type": "left_dealer_time", from_date: sdate, to_date: edate }
        }
        this.getDashboardRowData(params)
    }


    handleStartDateChange = date => {
        if (this.state.endDate && date > this.state.endDate) {
            this.setState({
                show: true,
                basicTitle: 'To Date should be greater than From Date',
                basicType: "danger",
                loadshow: 'show-n'
            });
        } else {
            this.setState({ startDate: date });
        }
    };

    handleEndDateChange = date => {
        if (this.state.startDate && date < this.state.startDate) {
            this.setState({
                show: true,
                basicTitle: 'To Date should be greater than From Date',
                basicType: "danger",
                loadshow: 'show-n'
            });
        } else {
            this.setState({ endDate: date });
        }
    };
    newFilter = (filterType, selOption) => {
        this.setState({ [filterType]: selOption });
    }

    render() {
        const { loadshow, overly } = this.state
        const dealerDetentionColDef = [
            {
                headerName: "Truck No",
                field: "Truck No",
                width: 150,
                chartDataType: "series"
            },
            {
                headerName: "FO Number",
                field: "FO Number",
                width: 150,
                chartDataType: "series"
            },
            // {
            //     headerName: "Invoice Time",
            //     field: "Invoice Time",
            //     width: 150,
            //     chartDataType: "series",
            //     valueGetter: params => {
            //         return !['',undefined,null].includes(params.data["Invoice Time"])?
            //              getHyphenDDMMMYYYYHHMM(params.data["Invoice Time"]) : "NA";
            //     }
            // },
            {
                headerName: "Transporter Name",
                field: "Transporter Name",
                width: 150,
                chartDataType: "series"
            },
            {
                headerName: "Transporter Code",
                field: "Transporter Code",
                width: 150,
                chartDataType: "series"
            },
            {
                headerName: "Plant Code",
                field: "Plant Code",
                width: 150,
                chartDataType: "series"
            },
            {
                headerName: "Dealer Code",
                field: "Dealer Code",
                width: 150,
                chartDataType: "series"
            },
            {
                headerName: "Base KM",
                field: "Base KM",
                width: 150,
                chartDataType: "series"
            },
            // {
            //     headerName: "KMS Range",
            //     field: "KMS Range",
            //     width: 150,
            //     chartDataType: "series"
            // },
            {
                headerName: "Dealer Name",
                field: "Dealer Name",
                width: 150,
                chartDataType: "series"
            },
            {
                headerName: "Dealer City",
                field: "Dealer City",
                width: 150,
                chartDataType: "series"
            },
            // {
            //     headerName: "Dealer State",
            //     field: "Dealer State",
            //     width: 150,
            //     chartDataType: "series"
            // },
            // {
            //     headerName: "Reporting Date",
            //     field: "Reporting Date Time 5 KM",
            //     width: 150,
            //     chartDataType: "series",
            //     valueGetter: params => {
            //         return !['',null,undefined].includes(params.data["Reporting Date Time 5 KM"]) ? getHyphenDDMMMYYYYHHMM(params.data["Reporting Date Time 5 KM"]) : "NA";
            //     }
            // },
            {
                headerName: "Reached Dealer",
                field: "Original Reporting Time",
                width: 150,
                chartDataType: "series",
                valueGetter: params => {
                    return !['',undefined,null].includes(params.data["Original Reporting Time"]) ?
                         getHyphenDDMMMYYYYHHMM(params.data["Original Reporting Time"]): "NA"
                }
            },
            {
                headerName: "Left Dealer",
                field: "Unloading Date Time",
                width: 150,
                chartDataType: "series",
                valueGetter: params => {
                    return !['',undefined,null].includes(params.data["Unloading Date Time"])? getHyphenDDMMMYYYYHHMM(params.data["Unloading Date Time"]): "NA"
                }
            },
            {
                headerName: "Unloading Delay (Hrs)",
                field: "Unloading Delay (Hrs)",
                width: 150,
                chartDataType: "series",
                valueGetter: params => {
                    return !['',undefined,null].includes(params.data["Unloading Delay (Hrs)"]) ? params.data["Unloading Delay (Hrs)"]: "NA";
                }
            },

            {
                headerName: "Status",
                field: "Status",
                width: 150,
                chartDataType: "series"
            },
            {
                headerName: "Force Closure Time",
                field: "force_closure_time",
                width: 150,
                chartDataType: "series",
                valueGetter: params => {
                return !['',undefined,null].includes(params.data.force_closure_time)? getHyphenDDMMMYYYYHHMM(params.data.force_closure_time) : "NA";
                }
            },
            {
                headerName: "Remarks",
                field: "Remarks",
                width: 150,
                chartDataType: "series"
            }
        ]
        return (
            <div className="container-fluid">
                <SweetAlert
                    show={this.state.show}
                    type={this.state.basicType}
                    title={this.state.basicTitle}
                    onConfirm={this.closeAlert}>
                </SweetAlert>
                <h5 className="col-xl-12">
                    <i className="icofont icofont-vehicle-delivery-van cus-i"></i> <span style={{ fontWeight: "600" }}>Dealer Detention Reports</span>
                </h5>
                <div className='row'>
                    <div className="card col-xl-12 col-lg-12">
                        {/* Truck Wise tab button data  */}
                        <div className={"card-body " + this.state.tab1} style={{ padding: '10px' }}>
                            <form className="row" onSubmit={this.getDealerDetails} style={{ margin: '10px' }}>
                                {/* <div className="form-group col-xl-2 col-lg-2">
                                    <label>Select Type </label>
                                    <Select
                                        className="border-radius-0"
                                        isMulti={false}
                                        id="selectedFilter"
                                        style={{ borderRadius: "0px" }}
                                        onChange={e => { this.setState({ selectedFilter: e.label }) }}
                                        placeholder = "Left Dealer Time"
                                        options={[{ label: "Invoice Time", value: "Invoice Time" }, { label: "Left Dealer Time", value: "Left Dealer Time" }]}
                                    />
                                </div> */}
                                <div className="col-xl-2 col-lg-2 form-group">
                                    <label>From Date</label>
                                    <DatePicker
                                        selected={this.state.startDate}
                                        onChange={this.handleStartDateChange.bind(this)}
                                        name="startDate"
                                        dateFormat="dd/MM/yyyy"
                                        className="datepicker-custom" />
                                </div>

                                <div className="col-xl-2 col-lg-2 form-group">
                                    <label>To Date</label>
                                    <DatePicker
                                        selected={this.state.endDate}
                                        onChange={this.handleEndDateChange.bind(this)}
                                        name="endDate"
                                        dateFormat="dd/MM/yyyy"
                                        className="datepicker-custom" />
                                </div>
                                <div className="form-group col-xl-2 col-lg-2" style={{ textAlign: "left", marginTop: "30px" }}>
                                    <button type="submit" className="btn btn-success">Submit</button>
                                </div>
                            </form>
                            {/* <hr style={{ border: '1px solid #c5bcbc' }} /> */}
                            <div className="col-xl-12 col-lg-12">
                                <div className="height-equal equal-height-lg" style={{ padding: '10px' }}>
                                    <div className="card-body" style={{ padding: '10px' }}>
                                        <div className='row'>
                                            {/* Dealer Detention Grid */}
                                            <div className="col-xl-12 col-lg-12">
                                                <div className={"ag-theme-balham mt-8"} style={{ height: '500px', width: '100%', paddingTop: "1rem" }}>
                                                    <AgGridReact
                                                        columnDefs={dealerDetentionColDef}
                                                        defaultColDef={this.state.defaultColDef}
                                                        rowData={this.state.rowData}
                                                        pagination={true}
                                                        paginationPageSize={50}
                                                        enableRangeSelection={true}
                                                        enableCellContextMenu={true}
                                                        sideBar={{
                                                            toolPanels: [
                                                                {
                                                                    id: "columns",
                                                                    labelDefault: "Columns",
                                                                    labelKey: "columns",
                                                                    iconKey: "columns",
                                                                    toolPanel: "agColumnsToolPanel",
                                                                    toolPanelParams: {
                                                                        suppressPivotMode: true,
                                                                        suppressRowGroups: true,
                                                                        suppressValues: true,
                                                                    }
                                                                },
                                                                {
                                                                    id: "filters",
                                                                    labelDefault: "Filters",
                                                                    labelKey: "filters",
                                                                    iconKey: "filter",
                                                                    toolPanel: "agFiltersToolPanel"
                                                                }
                                                            ]
                                                        }}
                                                        statusBar={{
                                                            statusPanels: [
                                                                {
                                                                    statusPanel: "agTotalAndFilteredRowCountComponent",
                                                                    align: "left"
                                                                },
                                                                {
                                                                    statusPanel: "agTotalRowCountComponent",
                                                                    align: "center"
                                                                },
                                                                { statusPanel: "agFilteredRowCountComponent" },
                                                                { statusPanel: "agSelectedRowCountComponent" },
                                                                { statusPanel: "agAggregationComponent" }
                                                            ]
                                                        }} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={"dataLoadpage " + (loadshow)}>
                </div>
                <div className={"dataLoadpageimg " + (loadshow)} style={{ position: "fixed", top: "43%" }}>
                    <div className="loader-box"><div className="loader-box"><div className="rotate dashed colored"></div></div></div>
                </div>
                <div className={"overlay-part " + (overly)} onClick={this.onClickHideAll}></div>
            </div>
        )

    }
}